import usePersistentInputState from '../../views/chat-view/usePersistentInputState';
import usePersistentAutoSubmitState from '../../views/chat-view/usePersistentLoadingForState';
import ChatProvider from './ChatContext';
import ChatService from '../../services/ChatService';
import { PropsWithChildren, useEffect, useMemo, } from 'react';
import { IChatService } from '../../services/IChatService';
import { useAuth } from '../auth/AuthContext';
import { useBackendEvents } from '../backend-events/BackendEventsContext';
import useFileUploadQueue from '../../views/chat-view/useFileUploadQueue';

const ChatServiceProvider: React.FC<PropsWithChildren<{ service?: IChatService; }>> = ({ children }) => {
    const persistentInputs = usePersistentInputState();
    const persistentAutoSubmit = usePersistentAutoSubmitState();
    const fileUploadQueue = useFileUploadQueue();
    const persistent = { ...persistentInputs, ...persistentAutoSubmit, ...fileUploadQueue };

    const { getAccessToken } = useAuth();
    const backendEvents = useBackendEvents();
    const service = useMemo(() => new ChatService(getAccessToken, backendEvents), [getAccessToken, backendEvents]);

    useEffect(() => {
        service.bindEvents();
        return () => service.unbindEvents();
    }, [service]);

    return <ChatProvider {...service} persistent={persistent}>
        {children}
    </ChatProvider>;
};

export default ChatServiceProvider;